import React from 'react';
import { IndigoAppContextType } from 'app/AppContext';
import { OrderDataRequired } from 'communication/types/order/Order';
import { applyTickSize } from 'utils/tickSize';

export const tickSizeCurrencyCellRenderer =
    (context: IndigoAppContextType) =>
    // eslint-disable-next-line react/display-name
    (props: { value: number; data: OrderDataRequired }) => {
        if (props.value !== undefined) {
            const exchangeRate = context.currencyFormat
                ? context.currencyFormat.exchangeRate!
                : 1;
            const value = props.value * exchangeRate;
            const formattedValue = applyTickSize(
                context.numberFormat,
                props.data.tickSize,
                value
            );
            return <span>{formattedValue}</span>;
        } else {
            return <span />;
        }
    };
